<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import type { RoutedCustomerViewComponentProps } from '@/types';
  import HistoryByMailHeaderBox from '@/components/historyPage/HistoryByMailHeaderBox.vue';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'HistoryView' });

  defineProps<RoutedCustomerViewComponentProps>();

  const { t } = useI18n();
  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();
  const HistoryListController = getAsyncComponentWithLoader(() => import('@/components/historyPage/list/HistoryListController.vue'));
</script>

<template>
  <PageContent
    :is-status-box-opened="isStatusBoxOpened"
    class="gap-6 md:gap-10 pb-14 md:pb-14"
  >
    <template #header>
      <h1 class="md:container">
        {{ t('pages.historyView.title') }}
      </h1>
      <HistoryByMailHeaderBox />
    </template>

    <HistoryListController />
  </PageContent>
</template>
